import Actions from './actions';
export const loginEmails = (state = {
  loading: true
}, action) => {
  switch (action.type) {
    case Actions.LOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        list: action.payload
      });
    case Actions.ADD_SUCCESS:
      return Object.assign({}, state, {
        list: [
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'list' does not exist on type '{ loading:... Remove this comment to see the full error message
        ...state.list.filter(email => email.id !== action.payload.id), action.payload]
      });
    case Actions.DELETE_SUCCESS:
      return Object.assign({}, state, {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'list' does not exist on type '{ loading:... Remove this comment to see the full error message
        list: state.list.filter(email => email.id !== action.payload.id)
      });
    case Actions.SET_PRIMARY_SUCCESS:
      return Object.assign({}, state, {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'list' does not exist on type '{ loading:... Remove this comment to see the full error message
        list: state.list.map(email => Object.assign({}, email, {
          primary: action.payload.id === email.id
        }))
      });
    case Actions.FAIL:
      return Object.assign({}, state, {
        fail: action.payload
      });
    case Actions.LOAD_FAIL:
      return {
        loading: false,
        loaded: false
      };
    case Actions.CLEAR_FAIL:
      return Object.assign({}, state, {
        fail: undefined
      });
    default:
      return state;
  }
};